import { render, staticRenderFns } from "./consume.vue?vue&type=template&id=50e5038f"
import script from "./consume.vue?vue&type=script&lang=ts"
export * from "./consume.vue?vue&type=script&lang=ts"
import style0 from "./consume.vue?vue&type=style&index=0&id=50e5038f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports